import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
export function usePageZoom() {
  var zoomPercent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 150;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    zoomLevel = _useState2[0],
    setZoomLevel = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    zoomedDPR = _useState4[0],
    setZoomedDPR = _useState4[1];
  useEffect(function () {
    if (typeof window === 'undefined') {
      return;
    }
    var zoomFactor = window.outerWidth / window.innerWidth;
    var currentDPR = window.devicePixelRatio;
    var baseDPR = parseFloat((currentDPR / zoomFactor).toFixed(2));
    var getZoomLevel = function getZoomLevel() {
      return Math.round(window.devicePixelRatio * 100);
    };

    // get zoom initial value per 100% page zoom
    var calculateZoomedDevicePixelRatio = function calculateZoomedDevicePixelRatio() {
      var basedZoom = Math.round(baseDPR * 100);
      var definiteZoom = Math.round(zoomPercent * basedZoom / 100);
      setZoomedDPR(definiteZoom);
    };
    calculateZoomedDevicePixelRatio();
    setZoomLevel(getZoomLevel());
    var handleResize = function handleResize() {
      setZoomLevel(getZoomLevel());
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    zoomLevel: zoomLevel,
    zoomedDPR: zoomedDPR
  };
}